import {useParams} from "react-router-dom";
import React, {useContext, useEffect, useRef} from "react";
import {DisplayToClipSizeId} from "../../utils/utils";
import {FetchContext} from "../../context/FetchContext";
import {AuthContext} from "../../context/AuthContext";
import {autorun} from "mobx";
import Box from "@mui/material/Box";
import {CompositionStore} from "../../librettoEditor/store/CompositionStore";
import {CompositionService} from "../../librettoEditor/services/CompositionService";
import LibrettoEditorTopbar from "./LibrettoEditorTopbar";
import LibrettoEditorInner from "./LibrettoEditorInner";
import CompositionBridge from "../../librettoEditor/CompositionBridge";


const LibrettoEditor = () => {

    const {projectId} = useParams();

    const compositionContainerRef = useRef(null);
    const canvasRef = useRef(null);

    const aspectRatioRef = useRef(null);
    const [aspectRatioId, setAspectRatioId] = React.useState(DisplayToClipSizeId(CompositionStore.display));

    const fetchContext = useContext(FetchContext);
    const authContext = useContext(AuthContext);

    // Initialize composition when canvas is ready
    useEffect(() => {
        if (canvasRef.current && !CompositionService.isInitialized()) {
            const initializeComposition = async () => {
                try {
                    // Create new composition instance
                    await CompositionService.initialize();
                    console.log("Composition initialized successfully");
                } catch (error) {
                    console.error("Error initializing composition:", error);
                }
            };

            initializeComposition().then(() => {
                CompositionBridge.init();
            })
        }
    }, [canvasRef.current]);

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            CompositionService.cleanup();
        };
    }, []);

    // Refresh project urls
    useEffect(() => {
        if (projectId === null) return;

        const LoadProjectUrls = async () => {
            try {
                await fetchContext.authAxios.get(`/project/${projectId}`, {
                    headers: {
                        Authorization: `Bearer ${authContext.getToken()}`,
                    }
                });
            } catch (error) {
                console.error("Error getting track urls:", error);
            }
        }

        LoadProjectUrls().then(() => {
            console.log("Loaded project urls");
        }).catch((e) => {
            console.log("Error refreshing project urls: ", e);
        });
        return () => {
        };
    }, [projectId]);

    useEffect(() => {
        const disposeAutorun = autorun(() => {
            const aspectRatioId = DisplayToClipSizeId(CompositionStore.display);
            setAspectRatioId(aspectRatioId);
        });

        // Cleanup autorun on component unmount
        return () => {
            disposeAutorun();
        };
    }, [setAspectRatioId]);


    const pageStyle = {
        display: 'flex',
        flexDirection: 'column',
        background: "#F3F4F5",
        paddingTop: "10px",
        paddingLeft: "25px",
        paddingRight: "10px",
        height: "100vh",
        width: "100vw",
        gap: "28px",
        overflow: 'hidden',
    }

    return (
        <Box sx={pageStyle}>
            <LibrettoEditorTopbar canvasRef={canvasRef} containerRef={compositionContainerRef} projectId={projectId}
                                 editTitle={"Sample"} textEditorVisible={false} videoPlayerVisible={true} aspectRatioRef={aspectRatioRef} aspectRatioId={aspectRatioId}
                                 editId={""}/>
            <LibrettoEditorInner
                projectId={projectId} compositionContainerRef={compositionContainerRef} canvasRef={canvasRef} videoPlayerVisible={true} textEditorVisible={true}/>
        </Box>
    )
}

export default LibrettoEditor;